export type ParsedOnboardingUrl =
	| { contentId: string; spaceKey: string; type: 'confluence-page'; url: string }
	| { type: 'unknown'; url: string };

/**
 * Parse a Confluence URL to extract page info.
 * Returns contentId/spaceKey for page URLs, or 'unknown' type for others.
 */
export function parseOnboardingUrl(url: string): ParsedOnboardingUrl {
	try {
		const match = new URL(url).pathname.match(/\/wiki\/spaces\/([^/]+)\/pages\/(\d+)/);
		if (match) {
			return { type: 'confluence-page', spaceKey: match[1], contentId: match[2], url };
		}
		return { type: 'unknown', url };
	} catch {
		return { type: 'unknown', url };
	}
}
